import React from 'react';

import productData from './productData';
import breadcrumbsData from './breadcrumbsData';

export default ({ type, ...props }) => {
  let data;

  if (type === 'product') {
    data = productData(props);
  }

  if (type === 'breadcrumbs') {
    data = breadcrumbsData(props);
  }

  return <script type="application/ld+json">{JSON.stringify(data)}</script>;
};
